/* ══════════════════════════════════════════════════════════════════════════
   INA KIMCHI / お届け希望日・時間帯セレクター ─ 補助スクリプト
   assets/ina-delivery-scheduler.js        version 2026-09-17a

   ■ このファイルは「あっても無くても店が動く」ことを前提に書く
     地域・日付・時間帯の選択肢は snippets/ina-delivery-scheduler.liquid が
     サーバ側で描画し、form="cart" で送信される。
     このスクリプトが担うのは次の3つだけ。
       1. 選んだ地域では届かない日付を無効化する
       2. 最短着日の時間帯を、その地域の到着帯に合わせて絞る
       3. G Pay 等フォームを経由しない決済のために /cart/update.js へ保存する
     よって、ここが落ちても購入は成立する。

   ■ 過去の失敗（繰り返さないこと）
     ・スニペットに <script> を直書き → <template> の中なので実行されない
     ・customElements.define → teleport 経路でアップグレードが不安定
     ・(window.requestAnimationFrame || setTimeout)(fn) → Illegal invocation
     ・JS で option を組み立てる → JS が死ぬと選択肢がゼロになる

   ■ 確認
     window.INA_DS.version / .refresh() / .lastError()
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var VERSION = '2026-09-17a';
  var PREF_KEY = 'ina_ds_pref';
  var lastError = null;

  /* 到着帯 → 最短着日に選べる時間帯の下限インデックス（select の option 順）
     option は [指定なし, 午前中, 12-14, 14-16, 16-18, 18-20, 19-21, 20-21]
     am    : 1（全部）
     pm    : 3  日本郵便の特記事項「午後表示なら午後2時以降を指定可」
     eve   : 4  夕方着。16時以降（推定）
     night : 5  夜間配達は17〜21時。安全側に18時以降（推定） */
  var BAND_MIN = { am: 1, pm: 3, eve: 4, night: 5 };
  var BAND_JP  = { am: '午前', pm: '午後', eve: '夕方', night: '夜' };

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  function save(root) {
    try {
      var dateEl = root.querySelector('[data-ds-date]:checked');
      var slotEl = root.querySelector('[data-ds-slot]');
      var payload = { attributes: {} };
      payload.attributes['お届け希望日'] = dateEl ? dateEl.value : '';
      payload.attributes['お届け希望時間帯'] = slotEl ? slotEl.value : '指定なし';
      window.fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })['catch'](function (e) { lastError = e; });
    } catch (e) { lastError = e; }
  }

  function applyRegion(root) {
    var pref = root.querySelector('[data-ds-pref]');
    var slot = root.querySelector('[data-ds-slot]');
    var note = root.querySelector('[data-ds-slotnote]');
    var rnote = root.querySelector('[data-ds-region-note]');
    if (!pref) return;

    var opt = pref.options[pref.selectedIndex];
    var lead = opt ? parseInt(opt.getAttribute('data-lead'), 10) : 0;
    var band = opt ? opt.getAttribute('data-band') : null;

    var labels = root.querySelectorAll('.ds-day');

    if (!lead) {
      // 地域未選択 ── 全部そのまま出しておく（選べないより出しておくほうが安全）
      each(labels, function (l) {
        l.className = 'ds-day';
        var input = l.querySelector('input');
        if (input) input.disabled = false;
      });
      if (rnote) rnote.textContent = '';
      if (slot) each(slot.options, function (o) { o.hidden = false; o.disabled = false; });
      if (note) {
        note.className = 'ds-micro';
        note.textContent = '冷蔵便でお届けします。受け取れる時間を選んでおくと、いちばんおいしい状態で会えます。';
      }
      return;
    }

    // 1) 届かない日を無効化し、最短の有効日を覚える
    var firstOk = null;
    each(labels, function (l) {
      var n = parseInt(l.getAttribute('data-lead'), 10);
      var input = l.querySelector('input');
      var off = n < lead;
      l.className = off ? 'ds-day is-off' : 'ds-day';
      if (input) {
        input.disabled = off;
        if (off && input.checked) input.checked = false;
      }
      if (!off && firstOk === null) firstOk = l;
    });

    if (rnote) {
      rnote.textContent = lead >= 2
        ? '京都からもう一日かかる地域です。日曜日には間に合いません。'
        : '';
    }

    // 2) 何も選ばれていなければ最短の有効日に寄せる（おまかせを明示選択中なら触らない）
    var checked = root.querySelector('[data-ds-date]:checked');
    if (!checked && firstOk) {
      var fi = firstOk.querySelector('input');
      if (fi) fi.checked = true;
      checked = fi;
    }

    // 3) 最短着日を選んでいる場合だけ、到着帯より早い時間帯を隠す
    var min = BAND_MIN[band] || 1;
    var onFirst = !!(checked && firstOk && checked === firstOk.querySelector('input'));
    if (slot) {
      var firstAllowedLabel = null;
      each(slot.options, function (o, idx) {
        var hide = onFirst && idx > 0 && idx < min;
        o.hidden = hide;
        o.disabled = hide;
        if (!hide && idx >= min && !firstAllowedLabel) firstAllowedLabel = o.value;
      });
      if (slot.selectedOptions && slot.selectedOptions.length && slot.selectedOptions[0].hidden) {
        slot.selectedIndex = 0; // 指定なし
      }
      if (note) {
        if (onFirst && min > 1) {
          note.className = 'ds-micro is-note';
          note.textContent = 'この日は' + (BAND_JP[band] || '') + 'の到着です。' +
            (firstAllowedLabel ? firstAllowedLabel + ' 以降からお選びいただけます。' : '');
        } else {
          note.className = 'ds-micro';
          note.textContent = '冷蔵便でお届けします。受け取れる時間を選んでおくと、いちばんおいしい状態で会えます。';
        }
      }
    }
  }

  function wire(root) {
    if (root._dsWired) return false;
    root._dsWired = true;

    var pref = root.querySelector('[data-ds-pref]');

    if (pref) {
      var saved = '';
      try { saved = localStorage.getItem(PREF_KEY) || ''; } catch (e) {}
      if (saved) {
        each(pref.options, function (o) { if (o.value === saved) pref.value = saved; });
      }
      pref.addEventListener('change', function () {
        try { localStorage.setItem(PREF_KEY, pref.value); } catch (e) {}
        applyRegion(root);
        save(root);
      });
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.hasAttribute && (t.hasAttribute('data-ds-date') || t.hasAttribute('data-ds-slot'))) {
        applyRegion(root);
        save(root);
      }
    });

    applyRegion(root);
    return true;
  }

  function refresh() {
    var done = 0;
    try {
      var roots = document.querySelectorAll('[data-ds-root]');
      for (var i = 0; i < roots.length; i++) { if (wire(roots[i])) done++; }
    } catch (e) {
      lastError = e;
      console.error('[ina-delivery-scheduler]', e);
    }
    return done;
  }

  window.INA_DS = {
    version: VERSION,
    refresh: refresh,
    lastError: function () { return lastError; }
  };

  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
    else refresh();
  } catch (e) { lastError = e; }

  try {
    var EVENTS = ['theme:update:cart', 'baseline:cart:update', 'theme:cart-drawer:open', 'cart-is-open'];
    for (var ei = 0; ei < EVENTS.length; ei++) document.addEventListener(EVENTS[ei], refresh);
  } catch (e) { lastError = e; }

  try {
    if (window.MutationObserver) {
      var begin = function () {
        try {
          new window.MutationObserver(function (recs) {
            for (var i = 0; i < recs.length; i++) {
              if (recs[i].addedNodes && recs[i].addedNodes.length) { refresh(); return; }
            }
          }).observe(document.body, { childList: true, subtree: true });
        } catch (e) { lastError = e; }
      };
      if (document.body) begin();
      else document.addEventListener('DOMContentLoaded', begin);
    }
  } catch (e) { lastError = e; }

  try {
    var delays = [0, 200, 600, 1500, 3000];
    for (var di = 0; di < delays.length; di++) window.setTimeout(refresh, delays[di]);
  } catch (e) { lastError = e; }
})();